import Vue from "vue"

export const leadConfirmationState = Vue.observable({ current: null })
const waiting = []

function showNext() {
  if (!leadConfirmationState.current && waiting.length) leadConfirmationState.current = waiting.shift()
}

export function confirmLeadChanges(review) {
  return new Promise((resolve) => {
    waiting.push({ items: review.items, resolve })
    showNext()
  })
}

export function finishLeadConfirmation(confirmed) {
  const current = leadConfirmationState.current
  if (!current) return
  leadConfirmationState.current = null
  current.resolve(confirmed === true)
  Vue.nextTick(showNext)
}
